'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index$1 = require('../../../../node_modules/classnames/index.js');

var index = require('../../../../node_modules/prop-types/index.js');

require('../../../../primitives/Button/Button.js');

require('../../../../primitives/Hero/Hero.js');

var Icon = require('../../../../primitives/Icon/Icon.js');

require('../../../../primitives/Link/Link.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var MobileNavItem = function MobileNavItem(props) {
  var className = props.className,
      children = props.children,
      name = props.name,
      secondary = props.secondary,
      onClick = props.onClick,
      hasChildren = props.hasChildren,
      link = props.link;
  var MobileNavItemClasses = index$1['default'](className, 'lanl-mobile-nav-item', secondary && 'lanl-mobile-nav-item--secondary');

  if (hasChildren) {
    return /*#__PURE__*/React__default['default'].createElement("li", {
      "data-testid": "lanl-mobile-nav-item",
      className: MobileNavItemClasses,
      onClick: onClick
    }, secondary && /*#__PURE__*/React__default['default'].createElement(Icon.Icon, {
      icon: "chevron-left",
      size: "sm",
      className: "me-2"
    }), name, !secondary && /*#__PURE__*/React__default['default'].createElement(Icon.Icon, {
      icon: "chevron-right",
      size: "sm"
    }), children);
  } else {
    return /*#__PURE__*/React__default['default'].createElement("a", {
      className: MobileNavItemClasses,
      href: link
    }, name);
  }
};

MobileNavItem.defaultProps = {
  hasChildren: true
};
MobileNavItem.propTypes = {
  children: index['default'].node,
  className: index['default'].string,
  hasChildren: index['default'].bool,
  link: index['default'].string,
  name: index['default'].string,
  onClick: index['default'].func,
  secondary: index['default'].bool
};
exports.MobileNavItem = MobileNavItem;
exports['default'] = MobileNavItem;